import { useServiceBreakdown } from '../hooks/useServiceBreakdown'
import { EmptyState } from './EmptyState'

interface ServiceData {
  service: string
  cost: number
  percentage: number
}

interface ServiceCostTableProps {
  data: ServiceData[]
}

export function ServiceCostTable({ data }: ServiceCostTableProps) {
  const { sorted } = useServiceBreakdown(data)

  if (!data || data.length === 0 || sorted.length === 0) {
    return (
      <EmptyState
        icon="table"
        title="No service cost data available"
        description="Service cost breakdown will appear here once data is available."
        className="py-8"
      />
    )
  }

  return (
    <table className="min-w-full text-sm">
      <thead className="bg-gray-50">
        <tr>
          <th className="text-left font-medium text-gray-500 py-2 px-3 text-xs uppercase tracking-wider">
            Service
          </th>
          <th className="text-right font-medium text-gray-500 py-2 px-3 text-xs uppercase tracking-wider">
            Cost
          </th>
          <th className="text-right font-medium text-gray-500 py-2 px-3 text-xs uppercase tracking-wider">
            %
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {sorted.map((row, idx) => (
          <tr key={row.service} className="hover:bg-gray-50 transition-colors">
            <td className="py-2.5 px-3 font-medium text-gray-900">{row.service}</td>
            <td className="text-right tabular-nums py-2.5 px-3 text-gray-700">
              $
              {row.cost.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
            <td className="text-right py-2.5 px-3 text-gray-500">{row.percentage.toFixed(1)}%</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
